import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: '173d5903-f508-404e-8ef2-19d40cfd8073',
  ENV: 'bondy',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: true,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 141,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
